<template>
  <div>
    <div
      class="box"
      style="border: 1px solid #ced4da; border-radius: 7px; padding: 15px"
    >
      <h4 style="color: #db0000">{{ data.b_number }}</h4>

      <h5>Branch: {{ data.b_address }}</h5>

      <h5>
        <b-badge variant="success">{{ data.b_rent_status }}</b-badge>
      </h5>

      <span v-if="data.b_renewed_till != null" class="expiry">
        expires on: {{ formatDate(data.b_renewed_till) }}</span
      >
    </div>

    <b-form @submit="payBox">
      <br />
      <br />

      <h5>Make Payment</h5>

      <div class="form-group mb-3 input-group input-text-wrapper">
        <div class="input-group-prepend">
          <span
            class="input-group-text"
            style="background-color: #ffffff; border: none"
          >
            <font-awesome-icon icon="money-bill" style="color: #ced4da" />
          </span>
        </div>
        <b-form-select v-model="mode" class="box-text-input" required>
          <b-select-option class="option" :value="null"
            >Payment Mode</b-select-option
          >
          <b-select-option class="option" value="Mobile Money"
            >Mobile Money</b-select-option
          >
        </b-form-select>
      </div>

      <div class="form-group mb-3 input-group input-text-wrapper">
        <div class="input-group-prepend">
          <span
            class="input-group-text"
            style="background-color: #ffffff; border: none"
          >
            <font-awesome-icon icon="clock" style="color: #ced4da" />
          </span>
        </div>
        <b-form-select v-model="duration" class="box-text-input" required>
          <b-select-option class="option" :value="null"
            >Duration</b-select-option
          >
          <b-select-option class="option" value="1">1 year</b-select-option>
          <b-select-option class="option" value="2">2 years</b-select-option>
          <b-select-option class="option" value="3">3 years</b-select-option>
        </b-form-select>
      </div>

      <div class="form-group mb-3 input-group input-text-wrapper">
        <div class="input-group-prepend">
          <span
            class="input-group-text"
            style="background-color: #ffffff; border: none"
          >
            <font-awesome-icon icon="phone" style="color: #ced4da" />
          </span>
        </div>
        <b-form-input
          class="box-text-input"
          v-model="phone"
          type="phone"
          required
          placeholder="Phone"
        >
        </b-form-input>
      </div>

      <br />

      <button
        class="form-control paymentButtonCard button"
        style="margin-bottom: 4%"
        type="submit"
      >
        Make Payment &nbsp;
        <b-spinner v-if="paymentSpinner" label="Loading..." small></b-spinner>
      </button>
    </b-form>

    <!-- <b-row  style="background: #db0000; padding:2px; margin: 0">
        </b-row>-->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Box",
  props: { data: null },
  data() {
    return {
      paymentSpinner: false,
      mode: null,
      duration: null,
      phone: null,
    };
  },
  computed: {
    ...mapGetters(["getPaymentResponse", "getClientId"]),
    payment_response() {
      return this.getPaymentResponse;
    },
  },
  watch: {
    payment_response(newValue) {
      alert(newValue.message);
    },
  },
  methods: {
    ...mapActions(["payForBox"]),
    formatDate(date) {
      var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      if (date != null) {
        let d = date.split(" ")[0];
        var sections = d.split("-");
        return (
          sections[2] + " " + months[parseInt(sections[1])] + ", " + sections[0]
        );
      } else {
        return "";
      }
    },
    payBox(e) {
      e.preventDefault();
      let data = {
        client_id: this.getClientId,
        phone: this.phone,
        mode: this.mode,
        duration: parseInt(this.duration),
      };
      console.log(JSON.stringify(data));
      this.payForBox(data);
    },
  },
};
</script>

<style scoped>
.box {
  margin: 10px;
  box-shadow: 5px 5px 5px #dedede;
  background: #fff;
  border-radius: 3px;
}

.box:hover {
  box-shadow: 2px 5px 5px 5px #d8d8d8;
}

.data {
  padding: 30px;
  width: 100%;
}

.label {
  color: #9f0012;
  font-weight: bold;
  font-size: 18px;
  display: block;
  line-height: 1;
}

.detail {
  color: #222;
  font-size: 14px;
  font-weight: bold;
  display: block;
  line-height: 1;
  margin-top: 5px;
}

.status {
  color: #fff;
  background: #096d09;
  font-size: 12px;
  border-radius: 3px;
  padding: 5px;
  display: block;
  line-height: 1;
  margin-top: 5px;
}

.expiry {
  color: #595959;
  background: #fff;
  font-size: 12px;
  font-style: italic;
  border-radius: 3px;
  padding-top: 5px;
  padding-bottom: 5px;
  display: block;
  line-height: 1;
  margin-top: 5px;
}

.button {
  background: #db0000;
  height: 35px;
  border: none;
  border-radius: 2px;
  color: #fff;
  padding: 6px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 12px;
}

.button:hover {
  background: #9f0012;
}

.input {
  width: 100%;
  margin-bottom: 10px;
  font-size: 12px;
}

.input-select {
  width: 100%;
  font-size: 12px;
}

.option {
  font-size: 12px;
}

.form {
  width: 100%;
  margin-top: 10px;
}

.paymentButtonCard {
  border: none;
  color: #ffffff;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  font-weight: bold;
  background: #db0000;
  height: 45px;
  border-radius: 3px;
  text-align: center;
  font-size: 15px;
  margin-top: 4%;
}

.input-text-wrapper {
  border: #ced4da 1px solid;
  padding: 3px;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 8px;
}

.box-text-input {
  border: none;
  font-size: 13px;
  height: 13vm;
  color: #8898aa;
  outline: none;
  box-shadow: none !important;
}
</style>
